import { render, staticRenderFns } from "./SaveOrDiscardDialog.vue?vue&type=template&id=ec149ce8&scoped=true&"
import script from "./SaveOrDiscardDialog.vue?vue&type=script&lang=js&"
export * from "./SaveOrDiscardDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec149ce8",
  null
  
)

export default component.exports